import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "container-fluid py-4 px-5" }
const _hoisted_2 = { class: "my-2" }
const _hoisted_3 = { class: "row mt-2" }

import { translation } from "../../lang/Translation";
import { BlockContentsDTO } from '../../../server/dto/BlockContentsDTO';
import { BlocklyService } from "../../biz/remote/BlocklyService";
import { SessionUser } from '../../utils/SessionUser';
import PresentationCardItem from "./sections/PresentationCardItem.vue";
import { ref, nextTick } from 'vue';
import ListHeader from "../../components/header/ListHeader.vue";
import DialogContainer from "../../components/dialog/DialogsContainer.vue";
import { useRoute } from 'vue-router';

/**
 * 動的ラベル
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'ClassPresentationPage',
  setup(__props) {

const t = translation; //
const list = ref<BlockContentsDTO[]>([])
const route = useRoute();

const class_name:string = route.params.class_name as string;


const load = async ()=>{
  const biz = new BlocklyService();
  const response = await biz.presentationList(SessionUser.instance.userId, class_name)
  list.value = response.data;
}
nextTick(async () => {
  console.log(`params ${class_name} `)
  await load();
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(DialogContainer),
    _createVNode(ListHeader),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", _hoisted_2, _toDisplayString(_unref(t).to("クラスメンバーそれぞれの最新プロジェクトがリストアップされます。","class_presentation_desc")), 1),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.contents.user_block_contents_id,
            class: "col-3"
          }, [
            _createVNode(PresentationCardItem, {
              item: item.contents,
              member: item.member,
              class: _normalizeClass({ }),
              "on-reload": load
            }, null, 8, ["item", "member"])
          ]))
        }), 128))
      ])
    ])
  ], 64))
}
}

})